import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

import ReceptorSuggestions from '../../../receptores/suggestions/ReceptorSuggestions';
import ReceptorFiscalInfoForm from '../../../receptores/upsert/components/ReceptorFiscalInfoForm';

class ReceptorSelection extends Component {
  state = {
    manualInfoCompletion: false,
    data: {},
    isValid: false,
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (
      !!this.props.data.Receptor &&
      this.props.data.Receptor.confirmed !== true &&
      this.props.data.Receptor.id !== this.state.data.id
    ) {
      this.setState(
        {
          data: {
            confirmed: true,
            ...this.props.data.Receptor,
          },
        },
        () => {
          this.props.onFormDataChange({
            ...this.props.data,
            Receptor: {
              confirmed: true,
              ...this.props.data.Receptor,
            },
          });

          this.handleOnReceptorManualInfoRequest();
        }
      );
    }
  };

  componentWillUnmount() {
    this.setState = () => {};
  }

  handleOnSelect = (item) => {
    const { data } = this.props;

    this.props.onFormDataChange({
      ...data,
      Receptor: {
        ...item,
        cp: item.cp || (item.direccion || {}).cp,
      },
    });
  };

  handleOnReceptorEditInfoRequest = () => {
    const { data } = this.props;

    this.setState({
      data: {
        ...this.props.data.Receptor,
      },
      isEdit: true,
    });

    this.props.onFormDataChange({
      ...data,
      Receptor: {
        ...data.Receptor,
      },
    });

    this.handleOnReceptorManualInfoRequest();
  };

  handleOnReceptorReset = (item) => {
    const { data } = this.props;

    this.props.onFormDataChange({
      ...data,
      Receptor: {},
    });

    this.setState({
      data: {},
      manualInfoCompletion: false,
      isValid: false,
      isEdit: false,
    });

    if (this.props.onManualInfoRequest) {
      this.props.onManualInfoRequest(false);
    }
  };

  handleOnReceptorEditCancel = () => {
    this.setState({
      data: {},
      manualInfoCompletion: false,
      isValid: false,
      isEdit: false,
    });

    if (this.props.onManualInfoRequest) {
      this.props.onManualInfoRequest(false);
    }
  };

  handleOnReceptorManualInfoRequest = () => {
    this.setState({
      manualInfoCompletion: true,
    });

    if (this.props.onManualInfoRequest) {
      this.props.onManualInfoRequest(true);
    }
  };

  handleOnFormDataChange = (event) => {
    this.setState({
      ...event,
    });
  };

  handleOnManualReceptorInfoSet = () => {
    this.handleOnSelect({
      ...this.state.data,
    });

    this.setState({
      data: {},
      manualInfoCompletion: false,
      isValid: false,
      isEdit: false,
    });

    if (this.props.onManualInfoRequest) {
      this.props.onManualInfoRequest(false);
    }
  };

  render() {
    const { isEdit, manualInfoCompletion, isValid, data: info } = this.state;
    const { autoFocus, data, legend, datos_fiscales_requeridos } = this.props;

    const isCompleted = !manualInfoCompletion && !!data.Receptor && !!data.Receptor.rfc;

    return (
      <div className="">
        {!manualInfoCompletion && (
          <ReceptorSuggestions
            autoFocus={autoFocus}
            data={data.Receptor}
            onSelect={this.handleOnSelect}
          />
        )}

        {!isCompleted && !!manualInfoCompletion && (
          <>
            <ReceptorFiscalInfoForm
              data={info}
              datos_fiscales_requeridos={datos_fiscales_requeridos}
              autoFocus={true}
              onFormDataChange={this.handleOnFormDataChange}
            />

            {!!legend && (
              <div>
                <p>{legend}</p>
              </div>
            )}

            <div>
              {!isEdit && (
                <Button
                  variant="secondary"
                  className="mt-3 mr-2"
                  onClick={this.handleOnReceptorReset}
                >
                  Cancelar
                </Button>
              )}

              {isEdit && (
                <Button
                  variant="secondary"
                  className="mt-3 mr-2"
                  onClick={this.handleOnReceptorEditCancel}
                >
                  Cancelar
                </Button>
              )}

              <Button
                variant="primary"
                className="mt-3"
                disabled={!isValid}
                onClick={this.handleOnManualReceptorInfoSet}
              >
                Confirmar
              </Button>
            </div>
          </>
        )}

        {isCompleted && (
          <div className="mt-3">
            <Button
              variant="secondary"
              className="mr-3"
              onClick={this.handleOnReceptorEditInfoRequest}
            >
              Editar
            </Button>

            <Button
              variant="secondary"
              className=""
              onClick={this.handleOnReceptorReset}
            >
              Cambiar
            </Button>
          </div>
        )}

        {!isCompleted && !manualInfoCompletion && (
          <div>
            <small className="help-block">
              <Button
                variant="link"
                onClick={this.handleOnReceptorManualInfoRequest}
              >
                + Agregar manualmente
              </Button>
            </small>
          </div>
        )}
      </div>
    );
  }
}

export default ReceptorSelection;
